import axios, { AxiosRequestConfig } from "axios";


const getDebtorBlockState = async (factoringId: string): Promise<any> => {
    const options: AxiosRequestConfig = {
        url: `/factoring/${factoringId}/debtor_block/`,
        method: "GET"
    };
    const response = await axios(options);
    return response.data;
};

const blockAllDebtors = async (
    factoringId: string,
    reason: string,
    appliesToFuture: boolean
): Promise<any> => {
    const options: AxiosRequestConfig = {
        url: `/factoring/${factoringId}/debtor_block/block/`,
        method: "POST",
        data: { reason, applies_to_future: appliesToFuture }
    };
    const response = await axios(options);
    return response.data;
};

const unblockAllDebtors = async (factoringId: string, reason: string): Promise<any> => {
    const options: AxiosRequestConfig = {
        url: `/factoring/${factoringId}/debtor_block/unblock/`,
        method: "POST",
        data: { reason }
    };
    const response = await axios(options);
    return response.data;
};

const getDebtorBlockEvents = async (factoringId: string): Promise<any> => {
    const options: AxiosRequestConfig = {
        url: `/factoring/${factoringId}/debtor_block/events/`,
        method: "GET"
    };
    const response = await axios(options);
    return response.data;
};

export default {
    getDebtorBlockState,
    blockAllDebtors,
    unblockAllDebtors,
    getDebtorBlockEvents,
};
